import { useEffect, useState } from 'react';
import { useTranslate } from 'react-translate-plus';

interface Props {
  title?: string;
  pageTitle?: string;
}

export const useDocumentTitle = ({ title, pageTitle }: Props) => {
  useEffect(() => {
    const next = `${pageTitle || ''}${title ? ' | ' + title : ''}`;
    document.title = next || 'Workstation Konfigurator';
  }, [title, pageTitle]);
};

/** useDocumentTitleV2 with localisated titles */
export const useDocumentTitleV2 = (localisationKey: string) => {
  const t = useTranslate('PageTitles');

  const [title, setTitle] = useState<string>('');

  useEffect(() => {
    if (!localisationKey) {
      return;
    }
    const translatedTitle = t(localisationKey) || 'Workstation Configurator';
    setTitle(translatedTitle);
    document.title = translatedTitle;
  }, [localisationKey, t]);

  return title;
};
